/* ============================================================
   PhotoSwipe zoom integration
   ---------------------------
   Requires window.RC_PSWP = { core, lightbox } to be set in the
   Liquid section (asset URLs are injected there).
   ============================================================ */
(function () {
  if (!window.RC_PSWP || !window.RC_PSWP.lightbox || !window.RC_PSWP.core) return;

  var lightbox = null;
  var lbReady = null;

  /* ======== Load + init PhotoSwipe lightbox once, on first use. ======== */
  function ensureLightbox() {
    if (lbReady) return lbReady;

    lbReady = import(window.RC_PSWP.lightbox).then(({ default: PhotoSwipeLightbox }) => {
      lightbox = new PhotoSwipeLightbox({
        pswpModule: () => import(window.RC_PSWP.core),
        bgOpacity: 0.92,
        wheelToZoom: false,
        showHideAnimationType: "none",
        initialZoomLevel: () => window.matchMedia("(max-width: 749px)").matches ? 0.40 : 0.50,
        secondaryZoomLevel: () => window.matchMedia("(max-width: 749px)").matches ? 0.55 : 1.3,
        maxZoomLevel: 2,            
        arrowPrev: false,
        arrowNext: false,
        close: false,
        loop: false,
        counter: false,
        bgClickAction: false,
        imageClickAction: "zoom",
        clickToCloseNonZoomable: false,
        pinchToClose: false,
        closeOnVerticalDrag: false
      });

      // Group prev / next / close into one .rc-modal-container-action-buttons div
      lightbox.on("uiRegister", function () {
        lightbox.pswp.ui.registerElement({
          name: "rcActionButtons",
          className: "rc-modal-container-action-buttons",
          appendTo: "root",
          onInit: function (el, pswp) {
            var ICON_ARROW =
              '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 60 60" width="60" height="60">' +
              '<polyline fill="none" stroke="currentColor" points="10.5 0.5 0.5 10.5 10.5 20.5" stroke-width="1.25"/>' +
              '</svg>';
            var ICON_CLOSE =
              '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 32 32" width="32" height="32">' +
              '<path d="M21 1L1 21M1 1L21 21" stroke="currentColor" stroke-linecap="square" stroke-linejoin="round"/>' +
              '</svg>';

            function makeButton(className, label, iconHTML, onClick) {
              var btn = document.createElement("button");
              btn.type = "button";
              btn.className = "pswp__button " + className;
              btn.setAttribute("aria-label", label);
              btn.title = label;
              btn.innerHTML = iconHTML;
              btn.onclick = onClick;
              return btn;
            }

            var prevBtn = makeButton("rc-modal-prev", "Previous", ICON_ARROW, function () { pswp.prev(); });
            var closeBtn = makeButton("rc-modal-close", "Close", ICON_CLOSE, function () { pswp.close(); });
            var nextBtn = makeButton("rc-modal-next", "Next", ICON_ARROW, function () { pswp.next(); });

            // flip the arrow for the "next" button
            var nextIcn = nextBtn.querySelector(".pswp__icn");
            if (nextIcn) nextIcn.style.transform = "scaleX(-1)";

            el.innerHTML = "";
            el.appendChild(prevBtn);
            el.appendChild(closeBtn);
            el.appendChild(nextBtn);

            // Add a class when there's no slide in that direction (style it yourself)
            function updateNav() {
              var total = pswp.getNumItems();
              prevBtn.classList.toggle("rc-modal-action-hidden", !(pswp.currIndex > 0));
              nextBtn.classList.toggle("rc-modal-action-hidden", !(pswp.currIndex < total - 1));
            }
            pswp.on("change", updateNav);
            updateNav();
          }
        });
      });

      lightbox.on("openingAnimationStart", function () {
        document.body.style.overflow = "hidden";
        document.body.classList.add("pswp-open");
      });

      lightbox.on("closingAnimationEnd", function () {
        document.body.style.overflow = "";
        document.body.classList.remove("pswp-open");
      });

      lightbox.on("bindEvents", function () {
        var pswp = lightbox.pswp;
        if (!pswp) return;

        // Desktop only — mobile uses native PhotoSwipe touch handling
        if (!window.matchMedia("(pointer: fine)").matches) return;

        function wheelHandler(e) {
          e.preventDefault();
          e.stopPropagation();

          var currSlide = pswp.currSlide;
          if (!currSlide || !currSlide.pan) return;

          if (currSlide.currZoomLevel <= currSlide.zoomLevels.fit) return;

          // Normalize deltaMode — mice use lines (1) or pages (2), trackpads use pixels (0)
          var scale = 1;
          if (e.deltaMode === 1) scale = 20;       // line mode → convert to pixels
          if (e.deltaMode === 2) scale = 100;      // page mode → convert to pixels

          var dx = Math.max(-50, Math.min(50, e.deltaX * scale));
          var dy = Math.max(-50, Math.min(50, e.deltaY * scale));

          // Apply easing — multiply by 0.6 to dampen movement and feel smooth
          currSlide.pan.x -= dx * 0.6;
          currSlide.pan.y -= dy * 0.6;
          currSlide.panTo(currSlide.pan.x, currSlide.pan.y);
        }

        pswp.scrollWrap.addEventListener("wheel", wheelHandler, { capture: true, passive: false });

        pswp.on("destroy", function () {
          if (pswp.scrollWrap) {
            pswp.scrollWrap.removeEventListener("wheel", wheelHandler, { capture: true });
          }
        });
      });

      // Mobile: block swipe-to-change-slide (pinch / zoom / pan still work; navigate via the buttons)
      lightbox.on("bindEvents", function () {
        if (!lightbox.pswp || !lightbox.pswp.mainScroll) return;
        if (window.matchMedia("(pointer: fine)").matches) return; // desktop — leave as-is

        var mainScroll = lightbox.pswp.mainScroll;
        var originalMoveTo = mainScroll.moveTo.bind(mainScroll);
        mainScroll.moveTo = function (x, dragging) {
          if (dragging) return;          // ignore finger-drag horizontal movement
          return originalMoveTo(x, dragging);
        };
      });

      lightbox.init();
      return lightbox;
    });

    return lbReady;
  }

  /* ======== Collect the visible image slides of a gallery as a PhotoSwipe dataSource. ======== */
  function collectSlides(gallery) {
    var viewer = gallery.querySelector("product-media-slider") || gallery;
    var triggers = viewer.querySelectorAll(".rc-pswp-trigger");
    var slides = [];

    triggers.forEach(function (a) {
      var slide = a.closest(".product-media-item");
      if (!slide) return;
      if (slide.classList.contains("slider-slide--clone")) return; // skip loop clones
      if (slide.style.display === "none") return;                  // skip filtered-out slides

      var img = slide.querySelector("img");

      slides.push({
        trigger: a,
        data: {
          src: a.getAttribute("href"),
          width: parseInt(a.dataset.pswpWidth, 10) || 0,
          height: parseInt(a.dataset.pswpHeight, 10) || 0,
          alt: a.getAttribute("aria-label") || (img && img.alt) || "",
          msrc: img ? (img.currentSrc || img.src) : undefined, // low-res placeholder
          element: img || a                                    // for the zoom animation
        }
      });
    });

    return slides;
  }

  /* Delegated click — fires for any product image trigger on the page. */
  document.addEventListener("click", function (e) {
    var trigger = e.target.closest(".rc-pswp-trigger");
    if (!trigger) return;

    e.preventDefault();

    var gallery = trigger.closest("media-gallery") || document;
    var collected = collectSlides(gallery);
    if (!collected.length) return;

    var dataSource = collected.map(function (s) { return s.data; });

    var index = collected.findIndex(function (s) { return s.trigger === trigger; });
    if (index < 0) index = 0;

    ensureLightbox().then(function (lb) {
      lb.loadAndOpen(index, dataSource);
    });
  });
})();